import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App.tsx'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import './index.css'
import { ENV } from './constants/env.ts'

const queryClient = new QueryClient()

export default function mount() {
  createRoot(document.getElementById('main-root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>
  )
}

mount()
const w = (window as any) || {}
w.ListingDrWidget = {
  default: mount,
  version: import.meta.env.VITE_CI_JOB_ID ?? 'dev',
}
if (console && console.log) {
  console.log('Listing Doctor ' + w.ListingDrWidget.version, ENV)
}
